import {
    FCL_EXPORT_BOOKING_REPORT_CONTAINER_TEUS,
    FCL_EXPORT_BOOKING_REPORT_LIST,
    FCL_EXPORT_BOOKING_REPORT_SUMMARY,
    FCL_EXPORT_SALESPERSON_REPORT_CONTACT_LIST,
    FCL_EXPORT_SALESPERSON_REPORT_CONTAINER_TEUS,
    FCL_EXPORT_SALESPERSON_REPORT_LIST,
    FCL_EXPORT_SALESPERSON_REPORT_SALES_PERSON_TEUS,
    FCL_EXPORT_SALESPERSON_REPORT_SUMMARY,
} from "./constant";
import { APICall } from "@/config/NetworkUtility";
import {
    buildFclExportBookingParams,
    buildFclExportSalespersonParams,
    buildReportQueryString,
    isFclReportApiSuccess,
    parseExportBookingReportResponse,
    parseExportSalespersonReportResponse,
} from "@/utility/fclReportHelpers";

/**
 * GET v1/FCLExportReports/GetBookingReport
 * @param {*} payload — FromDate, ToDate, ReportBy
 */
export const getFclExportBookingReport = (payload) => {
    return (dispatch) => {
        const queryString = buildReportQueryString(buildFclExportBookingParams(payload));
        const url = `v1/FCLExportReports/GetBookingReport?${queryString}`;

        return APICall("get", null, url).then(
            (result) => {
                if (isFclReportApiSuccess(result)) {
                    const { bookingList, summary, containerTeusList } =
                        parseExportBookingReportResponse(result);
                    dispatch({
                        type: FCL_EXPORT_BOOKING_REPORT_LIST,
                        payload: bookingList,
                    });
                    dispatch({
                        type: FCL_EXPORT_BOOKING_REPORT_SUMMARY,
                        payload: summary,
                    });
                    dispatch({
                        type: FCL_EXPORT_BOOKING_REPORT_CONTAINER_TEUS,
                        payload: containerTeusList,
                    });
                    return bookingList;
                }
                return Promise.reject();
            },
            (error) => Promise.reject(error)
        );
    };
};

/**
 * GET v1/FCLExportReports/GetBookingSalespersonReport
 * @param {*} payload — FromDate, ToDate, ReportBy, SalesPersonId
 */
export const getFclExportBookingSalespersonReport = (payload) => {
    return (dispatch) => {
        const queryString = buildReportQueryString(buildFclExportSalespersonParams(payload));
        const url = `v1/FCLExportReports/GetBookingSalespersonReport?${queryString}`;

        return APICall("get", null, url).then(
            (result) => {
                if (isFclReportApiSuccess(result)) {
                    const {
                        bookingList,
                        summary,
                        salesPersonTeus,
                        contactList,
                        containerTeusList,
                    } = parseExportSalespersonReportResponse(result);
                    dispatch({
                        type: FCL_EXPORT_SALESPERSON_REPORT_LIST,
                        payload: bookingList,
                    });
                    dispatch({
                        type: FCL_EXPORT_SALESPERSON_REPORT_SUMMARY,
                        payload: summary,
                    });
                    dispatch({
                        type: FCL_EXPORT_SALESPERSON_REPORT_SALES_PERSON_TEUS,
                        payload: salesPersonTeus,
                    });
                    dispatch({
                        type: FCL_EXPORT_SALESPERSON_REPORT_CONTACT_LIST,
                        payload: contactList,
                    });
                    dispatch({
                        type: FCL_EXPORT_SALESPERSON_REPORT_CONTAINER_TEUS,
                        payload: containerTeusList,
                    });
                    return bookingList;
                }
                return Promise.reject();
            },
            (error) => Promise.reject(error)
        );
    };
};
